import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CHECKOUT_URL } from '../constants/checkout';
const rows = [['Spending evenings creating worksheets', 'Everything ready in 5 minutes'], ['Searching for random drills online', 'Complete 360-page structured system'], ['Patchwork grammar teaching', 'Logical, measurable student progression'], ['Burned out and disorganized', 'Confident, professional, and in control'], ['Improvising cultural content', 'Deep cultural immersion built-in'], ['Low student engagement', 'Engagement Vault activities included']];
export function FinalCTA() {
  return <section className="border-y-4 border-[#d4af37] bg-[#0A0A0A] px-5 py-20" data-id="element-36" data-mp="qwq59n5g8fxa">
      <div className="mx-auto max-w-3xl text-center" data-id="element-37" data-mp="14uwpi0hh6heh">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-38" data-mp="14tdd4kyxwqhz">
          Your next Italian lesson can keep being improvised.{' '}
          <span className="text-[#d4af37]" data-id="element-39" data-mp="2c5y8xkq9sdcb">Or you can have a real system.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-[#B0B0C0]" data-id="element-40" data-mp="2h4sugufmgg04">
          Join hundreds of teachers and tutors worldwide who already plan their
          entire teaching year in minutes.
        </p>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-[#5A5A66] sm:hidden" data-id="element-41" data-mp="2r38lkxenfp9m">
          ← Scroll to see full table →
        </p>
        <div className="mt-3 overflow-x-auto sm:mt-10" data-id="element-42" data-mp="3023tcdxcd7f1">
          <div className="min-w-[520px] overflow-hidden border border-[#d4af37]/30 text-left" data-id="element-43" data-mp="300iuic3zv2bd">
            <div className="grid grid-cols-2 bg-[#16161F] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-44" data-mp="34vezsdy8rm6f">
              <p className="p-4 text-[#B0B0C0]" data-id="element-45" data-mp="3eri2pm0x3ouf">Without Italiano Ready™</p>
              <p className="border-l border-[#d4af37]/30 p-4 text-[#d4af37]" data-id="element-46" data-mp="3epf104qek79v">
                With Italiano Ready™
              </p>
            </div>
            {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-[#d4af37]/20 text-xs sm:text-sm" data-id="element-47" data-mp="1jm8xm5z3ij10">
                <p className="flex gap-2 p-4 font-medium text-[#B0B0C0]" data-id="element-48" data-mp="1shovqz6vvkce">
                  <span className="text-red-400" data-id="element-49" data-mp="1npezz2j37q27">×</span>
                  {without}
                </p>
                <p className="flex gap-2 border-l border-[#d4af37]/20 bg-[#d4af37]/5 p-4 font-semibold text-white" data-id="element-50" data-mp="22ebf1jjka3cb">
                  <CheckCircle2Icon className="h-4 w-4 shrink-0 text-[#d4af37]" data-id="element-51" data-mp="1xeot8lpo3erw" />
                  {withSystem}
                </p>
              </div>)}
          </div>
        </div>
        <div className="my-9" data-id="element-52" data-mp="27dnzxyqvh0c9">
          <CountdownTimer dark data-id="element-53" data-mp="27epeid73k4yq" />
        </div>
        <div className="border-2 border-[#d4af37] bg-[#16161F] p-7 text-left" data-id="element-54" data-mp="h18gp6z8r5q2">
          <p className="text-xs font-bold uppercase tracking-widest text-[#d4af37]" data-id="element-55" data-mp="h3bb037ffl0l">
            Complete package
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-56" data-mp="2vg8w1ff0raw">
            ITALIANO READY™ — 6-in-1 Box Set + 5 Strategic Bonuses
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-57" data-mp="6wry45udnaik">
            <div data-id="element-58" data-mp="3pcc8ck5g2wyn">
              <p className="text-sm font-bold text-[#B0B0C0] line-through" data-id="element-59" data-mp="3pardetf7xc09">
                $97
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-60" data-mp="3u8szzoburtgh">
                $27
              </p>
            </div>
            <p className="bg-[#d4af37] px-3 py-2 text-xs font-bold uppercase" data-id="element-61" data-mp="3kc7uz2zu2icn">
              Save $70
            </p>
          </div>
        </div>
        <a href={CHECKOUT_URL} className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-base font-bold sm:text-xl" data-id="element-62" data-mp="36e9ffu9s0fvk">
          GET ITALIANO READY™ NOW — $27
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-[#B0B0C0]" data-id="element-63" data-mp="14m3eozae12w5">
          <span className="flex gap-1" data-id="element-64" data-mp="19ibyipzj5k9n">
            <LockKeyholeIcon className="h-4 w-4 text-[#d4af37]" data-id="element-65" data-mp="35o2urxi5c1y7" />
            Secure payment
          </span>
          <span className="flex gap-1" data-id="element-66" data-mp="30o6pzw1mk6hl">
            <ZapIcon className="h-4 w-4 text-[#d4af37]" data-id="element-67" data-mp="30mdkik2qzsb6" />
            Instant access
          </span>
          <span className="flex gap-1" data-id="element-68" data-mp="2vrgezn4og131">
            <ShieldCheckIcon className="h-4 w-4 text-[#d4af37]" data-id="element-69" data-mp="2robe1p08w7gi" />
            7-day guarantee
          </span>
        </div>
      </div>
    </section>;
}